/* eslint @ngrx/prefer-effect-callback-in-block-statement: off */
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

import { SpinnerActions } from './spinner-state.actions';
import { selectAuxiliaryStartTime, selectPrimaryStartTime } from './spinner-state.selectors';

declare let FS: { event: Function };

const SPINNER_EMIT_THRESHOLD_SECONDS = 10.8;

@Injectable()
export class SpinnerStateEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);

  stopPrimarySpinner$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SpinnerActions.stopPrimary),
        concatLatestFrom(() => this.store.select(selectPrimaryStartTime)),
        tap(([{ source }, startMS]) => this.trackTime(startMS, Date.now(), source))
      ),
    { dispatch: false }
  );

  stopAuxiliarySpinner$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SpinnerActions.stopAuxiliary),
        concatLatestFrom(() => this.store.select(selectAuxiliaryStartTime)),
        tap(([{ source }, startMS]) => this.trackTime(startMS, Date.now(), source))
      ),
    { dispatch: false }
  );

  trackTime(startMS: number, endMS: number, source?: string): void {
    if (!window.hasOwnProperty('FS')) return;
    const time = (endMS - startMS) / 1000;
    // Preserves the pre-fix effective filter (~11s): the old code divided by 3600 instead of 1000
    // and gated on >= 3, i.e. >= 10800ms. Expressed here in the corrected unit, not silently at >= 3s.
    if (time >= SPINNER_EMIT_THRESHOLD_SECONDS) FS.event('Spinner Time', { time, source });
  }
}
